import PageLayout from "pages/layout/PageLayout"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useAppSelector } from "hooks/useApp"
import { PATH } from "constants/path"
import { pushTo } from "helpers/history"
import { hasPermission } from "helpers/permissions"
import { PERMISSIONS } from "constants/permissions"
import { HeaderBreadcrumbInfo } from "components/HeaderInfo/HeaderInfo"
import Breadcrumbs from "components/Breadcrumbs"
import { BreadcrumbsDetail } from "components/Breadcrumbs/types"
import TabItem from "pages/projects/molecules/TabItem"
import Projects from "pages/projects/Projects"
import LabelHeader from "pages/project-component/molecules/LabelHeader"
import { formatDate } from "helpers/utils"
import { getGroupsOrganizationDetailMiddleware } from "./groups.api"
import { GroupsOrganizationResponse } from "./groups.type"
import { GroupMemberPage } from "./GroupMemberPage"
import { GroupPermissionContext } from "./GroupPermissionContext"
import { useWindowSize } from "helpers/hooks"

export const GroupDetailPage = () => {
  const { isMobile } = useWindowSize()
  const { id } = useParams<{ id: string }>()
  const userInfo = useAppSelector((state) => state.userInfo)
  const [groupsDetail, setGroupsDetail] = useState<GroupsOrganizationResponse>({
    id: "",
    name: "",
    description: "",
  })
  const [tab, setTab] = useState<string>("projects")
  const [totalUser, setTotalUser] = useState<number>(0)
  const [totalProject, setTotalProject] = useState<number>(0)
  const [groupPermission, setGroupPermission] = useState<string[]>([])

  useEffect(() => {
    if (!userInfo?.id) {
      return
    }

    if (!hasPermission(userInfo, PERMISSIONS.GROUP_ORGANIZATION_VIEW)) {
      pushTo(PATH.notFound)
      return
    }
  }, [userInfo?.id])

  useEffect(() => {
    if (id) {
      fetchGroupDetail()
    }
  }, [id])

  const fetchGroupDetail = async () => {
    const response = await getGroupsOrganizationDetailMiddleware(id)
    if (response) {
      setGroupsDetail(response)
      setTotalUser(response?.memberCounts || 0)
      setTotalProject(response?.projectCounts || 0)
      setGroupPermission(response.groupPermissions || [])
    }
  }

  const listBreadcrumbs: BreadcrumbsDetail[] = [
    {
      name: "Groups",
      path: "",
      onCustomRouter: () => {
        pushTo(PATH.userGroups, undefined, undefined, { tab: "Groups" })
      },
    },
    {
      name: groupsDetail?.name,
    },
  ]

  const renderTab = () => {
    return (
      <div className="flex items-center absolute  left-[24px] top-[19px]">
        <TabItem
          title={`Projects (${totalProject})`}
          style={{
            marginRight: isMobile ? 0 : 24,
          }}
          isActive={tab === "projects"}
          onClick={() => setTab("projects")}
        />
        <TabItem
          title={`Members (${totalUser})`}
          isActive={tab === "members"}
          onClick={() => setTab("members")}
        />
      </div>
    )
  }
  const renderBody = () => {
    if (tab === "projects") {
      return (
        <Projects
          orginGroupId={id}
          callGroupsOrganizationDetail={fetchGroupDetail}
        />
      )
    }
    return (
      <GroupMemberPage
        groupId={id}
        callGroupsOrganizationDetail={fetchGroupDetail}
      />
    )
  }

  return (
    <GroupPermissionContext.Provider value={{ permissions: groupPermission }}>
      <PageLayout
        childrenHeader={
          <HeaderBreadcrumbInfo>
            <Breadcrumbs
              listBreadcrumbs={listBreadcrumbs}
              className="flex w-full"
              overflow
            />
            {groupsDetail?.created_at ? (
              <LabelHeader
                title="Created:"
                label={formatDate(groupsDetail?.created_at, "DD MMM yyyy")}
              />
            ) : null}
          </HeaderBreadcrumbInfo>
        }
        heightHeader={48}
        contentClass="relative"
      >
        {renderBody()}
        {renderTab()}
      </PageLayout>
    </GroupPermissionContext.Provider>
  )
}
